<template>
    <div id="js-user-wrap" class="container">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="box-card-title">CPE申报</span>
                <router-link to="/renewal">
                    <el-button size="small" type="primary" class="return-button">返回</el-button>
                </router-link>
                <router-link to="/cpePolicy">
                    <el-button size="small" type="primary" class="return-button">证书维持政策</el-button>
                </router-link>
                <router-link to="/cpeApply">
                    <el-button size="small" type="primary" class="return-button">CPE申报</el-button>
                </router-link>
                <router-link to="/cpeActivity">
                    <el-button size="small" type="primary" class="return-button">CPE近期活动</el-button>
                </router-link>
<!--                <router-link to="/renewal">-->
<!--                    <el-button size="small" type="primary" class="return-button">证书维持</el-button>-->
<!--                </router-link>-->

            </div>

            <el-table :data="cpeList" style="width: 100%">
                <el-table-column fixed fit prop="categoryName" label="项目名称" ></el-table-column>
                <el-table-column prop="categoryParentName" label="类别"  ></el-table-column>
                <el-table-column prop="startTime" label="开始时间" width="180" align="center" :formatter="dateFormat"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="180" align="center"  :formatter="dateFormat"></el-table-column>
                <el-table-column prop="num" label="CPE" width="80" align="center"></el-table-column>
<!--                <el-table-column prop="reason" label="原因" width="300" align="center"></el-table-column>-->
                <el-table-column prop="state" label="状态" width="120" align="left">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.state === 1">审核中</span>
                        <span  v-if="scope.row.state === 2">已通过</span>
                        <span  v-if="scope.row.state === 3">
                            不通过
                            <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                <div slot="content">{{scope.row.reason}}</div>
                                <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>
                            </el-tooltip>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state === 1" @click="deleteCpe(scope.row.id)"  size="small" type="primary">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center; margin-top: 10px">
                <el-button size="small" type="primary" class="return-button" @click="openApply()">继续申报</el-button>
            </div>
            <el-pagination @current-change="getData" @size-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
            </el-pagination>

        </el-card>

        <el-dialog title="CPE活动申报" :visible.sync="applyVisIble" center :close-on-click-modal="false" @close="onClose">
            <el-form :model="cpeApplyForm" :rules="rules" ref="cpeApply" label-width="120px">
                <el-form-item label="活动时间" prop="timeRange">
                    <el-date-picker
                            v-model="cpeApplyForm.timeRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="类别项目" prop="category">
                    <el-cascader
                            expand-trigger="hover"
                            :options="categoryList"
                            v-model="cpeApplyForm.category" style="width: 100%;max-width: 440px">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="活动提供单位" prop="activityProvider">
                    <el-input v-model="cpeApplyForm.activityProvider"></el-input>
                </el-form-item>
                <el-form-item label="活动相关描述" prop="activityDes">
                    <el-input type="textarea" v-model="cpeApplyForm.activityDes"></el-input>
                </el-form-item>
                <el-form-item  label="活动相关证明"  required>
                        <el-upload
                                :multiple="true"
                                ref="upload"
                                action="/api/cpe/uploadAttach"
                                :on-preview="handleUploadPreview"
                                :on-remove="handleUploadRemove"
                                :on-success="handleUploadSuccess"
                                :on-error="handleUploadError"
                                :file-list="fileList"
                                :auto-upload="true">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            <div slot="tip" class="el-upload__tip" style="line-height: 16px">
                                1.只能上传jpg/png/docx/pdf文件，且不超过5MB <br/>
                                2.相关证明材料包含但不限于现场参会照片、签到表、认证证书、获奖证书、文章发布链接等。<br/>
                                3.每份证明材料建议包含主办机构名称、活动主题、活动描述、活动日期等主要信息，以便审核通过。</div>
                            <div v-if="fileError" class="el-form-item__error">请上传相关证明</div>
                        </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onClose">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import VueQr from 'vue-qr';
import dateFormat from 'format-datetime';
import ca from "element-ui/src/locale/lang/ca";
import Bus from '../bus.js';
export default {
    components:{VueQr},
    data:()=>{
        return {
            categoryList:[],
            certificateList:[],
            cpeApplyForm:{},
            fileList:[],
            fileUploadSuccess:[],
            cpeList:[],
            searchParam:{
                pageNum:1, 
                pageSize:20
            },
            totalNumber:0,
            applyVisIble: false,
            rules: {
                timeRange: [
                    {required: true, message: "请选择活动时间", trigger: ["blur"]}
                ],
                category: [
                    {required: true, message: "请选择类别项目", trigger: ["change"]},
                ],
                activityProvider: [
                    {required: true, message: "请输入活动提供单位名称", trigger: ["blur"]},
                ],
                activityDes: [
                    {required: true, message: "请输入活动相关描述", trigger: ["blur"]},
                ],
                // attachFiles: [
                //     {required: true, message: "请上传相关相关证明", trigger:["change"]},
                // ],
            },
            fileError:false,
        };
    },
    created() {
        if (this.$store.state.userInfo&&this.$store.state.userInfo.chName) {
            this.getData();
            this.getCategory();
        }
    },
    computed: {
        systemConfig : function () {
            return this.$store.state.systemConfig;
        },
        isLogin: function() {
            return this.$store.state.userInfo&&this.$store.state.userInfo.chName ? true: false;
        },
    },
    methods: {
        async getCategory() {
            let res = await this.$axios.get('/cpe/categoryList');
            if (res.code === 200) {
                let categoryList1 = [];
                for (let c1 of res.data) {
                    console.log(c1);
                    let categoryList2 = [];
                    if (c1.categoryList) {
                        for (let c2 of c1.categoryList) {
                            categoryList2.push({value:c2.id,label:c2.categoryName + "  ("+ c2.num +"CPE)"})
                        }
                    }

                    categoryList1.push({value:c1.id, label: c1.categoryName, children: categoryList2})
                }
                this.categoryList = categoryList1;
            }
        },
        async getData() { 
            let res = await this.$axios.post('/cpe/selectByPage',this.searchParam);
            if (res.code == 200) {
                this.cpeList = res.data.list;                  //订单列表
                this.totalNumber = res.data.total;
            }
        },
        openApply() {
            if(this.isLogin){
                this.applyVisIble =true;
            } else {
                Bus.$emit('toOpenLigon',true);
            }
        },
        handleUploadRemove(file, fileList) {
            console.log(file, fileList);
        },
        handleUploadPreview(file) {
            console.log(file);
        },
        handleUploadSuccess(response, file, fileList) {
            if (response.code === 200) {
                this.fileUploadSuccess.push(response.data)
                this.cpeApplyForm.attachFiles = JSON.stringify(this.fileUploadSuccess);
                this.fileError = false;
            }
        },
        handleUploadError(error, file, fileList) {
            console.log(error,file, fileList)
        },
        async onSubmit() {
            let c1 = await this.$refs["cpeApply"].validate().catch(error=> {
                return Promise.resolve(false);
            });
            if (this.fileUploadSuccess.length <1) {
                this.fileError=true;
                c1 = false
            }
            if (!c1) {
                return;
            }

            this.cpeApplyForm.categoryParentId = this.cpeApplyForm.category[0];
            this.cpeApplyForm.categoryId = this.cpeApplyForm.category[1];
            this.cpeApplyForm.attachFilesList = this.fileUploadSuccess;
            this.cpeApplyForm.startTime = dateFormat(this.cpeApplyForm.timeRange[0], 'yyyy-MM-dd HH:mm:ss')
            this.cpeApplyForm.endTime = dateFormat(this.cpeApplyForm.timeRange[1], 'yyyy-MM-dd HH:mm:ss')

            let res = await this.$axios.post("/cpe/insert", this.cpeApplyForm);
            if (res.code === 200) {
                this.cpeApplyForm = {}
                this.fileUploadSuccess=[];
                this.$refs.upload.clearFiles();
                this.onClose();
                this.getData();
            }

        },
        onClose() {
            this.applyVisIble=false;
            this.$refs["cpeApply"].clearValidate();
            this.fileError=false;
        },
        async deleteCpe(id) {
            let confirm = await this.$confirm('此操作将永久删除申请记录，是否继续？',{type:'warning'}).catch(err=>{return Promise.resolve(false)});
            if (!confirm) {
                return;
            }

            let res = await this.$axios.get(`/cpe/delete/${id}`);
            if (res.code === 200) {
                this.getData();
            }
        },
        dateFormat(row, column, dateTime, index) {
            if (dateTime) {
                return dateTime.substring(0,10);
            } else {
                return dateTime;
            }
        }
    },
    mounted() {

    }
};
</script>


<style scoped>
.tips{
    color:#f01414;
    font-size: 14px;
    margin-top: 7px;
}
.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 1300px;
}
.box-card {
    width: 100%;
    margin-top: 10px;
}
.el-input {
    width: 80%;
}
.return-button {
    float: right;
    margin-left: 20px;
}
@media screen and (max-width: 767px) {
    .el-card {
        box-shadow: none;
        border: none;
    }
}
.el-upload__tip {
    line-height: 10px;
}

</style>
